module.exports = __webpack_public_path__ + "assets/img/serve3.9c7b69d1.png";